export default __webpack_public_path__ + "static/media/breakfast-hash.a66a025f.jpeg";